<template>
  <div class="div-conteudo">
    <transition name="modal" v-if="carregando">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <img src="../../assets/imagens/loadingSpinner.gif" alt="Roda de carregamento girando">
            <label>Aguarde. Carregando.</label>
          </div>
        </div>
      </div>
    </transition>
    <div class="fora" v-else>
      <div class="index centro">
        <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" />
        <div class="topo-index">
          <h1>Servidores</h1>
          <router-link v-if="temPermissao.admin" :to="{
            name: 'ServidorNew',
          }">
            <span>+</span> Novo(a) Servidor(a)
          </router-link>
        </div>
        <div class="caixa-pesquisa"> <!-- MUDAR ITENS DA PESQUISA -->
          <h2 @click="tooglePesquisa()">
            Pesquisa
            <span>
              <template v-if="!exibirPesquisa">&#9650;</template>
              <template v-else>&#9660;</template>
            </span>
          </h2>
          <transition name="slide">
            <form @submit.prevent="fazerBusca" v-if="!exibirPesquisa">
              <div class = "row2-data">
                <div class="item">
                  <label> CPF: </label>
                  <the-mask :mask="['###.###.###-##']" v-model='filtro.cpf' placeholder="Digite o CPF" />
                </div>
                <div class="item">
                  <label> Nome: </label>
                  <input type="text" placeholder="Digite o nome" v-model="filtro.nome" />
                </div>
                <div class="item">
                  <label> Cargo: </label>
                  <!--<input type="text" placeholder="Digite o cargo" v-model="filtro.cargo" />-->
                  <v-select
                    class="vselect"
                    v-model="filtro.cargo"  
                    id="selectedCargo" 
                    :options="paginated"
                    label="nome" 
                    placeholder="Digite o nome do cargo"
                    :filterable="false" 
                    @search="onSearch"
                    @input="onCargoSelect">
                    <li slot="list-footer" class="pagination">
                        <button :disabled="!hasPrevPage" @click.prevent="offset -= limit">Anterior</button>
                        <button :disabled="!hasNextPage" @click.prevent="offset += limit">Próxima</button>
                    </li>
                  </v-select>
                </div>      
              </div>
              <div class="botoes-pesquisa">
                <div class="bt-pesquisa">
                  <button title="Pesquisar" type="submit">
                    <img src="../../assets/imagens/pesquisa.png" class="pesquisa" alt=" " />
                    Pesquisar
                  </button>
                </div>
                <div class="bt-limpar">
                  <button title="Limpar" @click="limparFiltro()">
                    <img src="../../assets/imagens/icon-eraser.png" class="limpar" alt=" " />
                    Limpar Filtros
                  </button>
                </div>
              </div>
            </form>
          </transition>
        </div>
        <div class="n-div">
          <div class="nresultados" v-show="!carregando">
            <label>Total de Resultados: {{ this.totalResultadosTexto }}</label>
          </div>
          <div class="npagina" v-show="!carregando">
            <label>Resultados por Página </label>
            <select :value="qtd_por_pagina" @input="mudouQtdPagina">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>
        <div v-if="temPermissao.admin || temPermissao.gpd" class="container-tabela">
          <TabelaResultadosServidores :servidores="servidores" :servidor="servidor"
            v-if="!carregando && !erro && !erroFiltro">
          </TabelaResultadosServidores>
        </div>
        <div v-else class="container-tabela">
          <TabelaResultadosServidoresUsuario :servidores="servidores" :servidor="servidor"
            v-if="!carregando && !erro && !erroFiltro">
          </TabelaResultadosServidoresUsuario>
        </div>
        <paginate v-if="!carregandoFiltro && !carregando" v-model="pagina" :page-count="pageCount"
            :click-handler="mudouPagina" :prev-text="'Anterior'" :next-text="'Próxima'" :container-class="'className'"
            active-class="active-page"></paginate>
      </div>
    </div>
  </div>
</template>

<script>
  import Paginate from "vuejs-paginate";
  import tryParseInt from "../../helpers/tryParseInt";
  import metaDados from "../../helpers/metaDados";
  import vSelect from "vue-select";
  import "vue-select/dist/vue-select.css";
  import Auth from '../../services/Auth';

  import TabelaResultadosServidores from "../../components/servidores/TabelaResultadosServidores.vue";
  import ServidorApi from "../../services/ServidorApi";
  import MsgErroFormularios from "../../components/MsgErroFormularios.vue";
  import TabelaResultadosServidoresUsuario from "../../components/servidores/TabelaResultadosServidoresUsuario.vue";

  export default {
    name: "Servidor",
    metaInfo() {
      return {
        title: "Servidores",
        titleTemplate: "%s - Casa Civil do Estado de Goiás",
        meta: [
          {
            vmid: "description",
            name: "description",
            property: "description",
            content:
              "Página de acesso e pesquisa de todos os servidores realizados.",
          },
          {
            vmid: "og:description",
            property: "og:description",
            content:
              "Página de acesso e pesquisa de todos os servidores realizados.",
          },
          {
            vmid: "og:title",
            property: "og:title",
            content: "Servidores - Casa Civil do Estado de Goiás",
          },
          ...metaDados(this.$route),
        ],
      };
    },
    data() {
      return {
        temPermissao: null,
        servidores: [],
        servidor: null,
        carregando: true,
        msgErros: {
          servidor: '',
        },
        erro: false,
        totalResultados: null,
        totalResultadosTexto: null,
        pagina: 1,
        qtd_por_pagina: 10,
        filtro: {
          cpf: null,
          nome: null,
          cargo: null,
        },
        search: '',
        offset: 0,
        limit: 10,
        cargos: [],
        selectedCargo: [],
        exibirPesquisa: true,
        carregandoFiltro: false,
        erroFiltro: false,
      };
    },
    components: {
      MsgErroFormularios,
      TabelaResultadosServidores,
      TabelaResultadosServidoresUsuario,
      Paginate,
      vSelect,
    },
    created() {
      this.servidorApi = new ServidorApi();
      let auth = new Auth();
      this.carregarQtdPorPagina();
      this.carregarValoresFiltro();
      this.carregarServidor();
      this.carregarCargos();
      this.temPermissao = auth.temPermissao;
    },
    watch: {
      $route: function (to, from) {
        const mudouQuery =
          to.query.pagina != from.query.pagina ||
          to.query.qtd_por_pagina != from.query.qtd_por_pagina ||
          to.query.cpf != from.query.cpf ||
          to.query.nome != from.query.nome ||
          to.query.cargo != from.query.cargo
        if (
          from.name == "Servidor" &&
          to.name == "Servidor" &&
          mudouQuery
        ) {
          this.carregarValoresFiltro();
          this.carregarServidor();
        }
      },
    },
    methods: {
      onSearch(query) {
        this.search = query
        this.offset = 0
      },
      onCargoSelect(selectedCargo) {
        this.filtro.cargo = selectedCargo.nome;
      },
      tooglePesquisa: function () {
        this.exibirPesquisa = !this.exibirPesquisa;
      },
      fazerBusca() {
        this.$router.push({
          name: "Servidor",
          query: {
            ...this.filtro,
            pagina: 1,
            qtd_por_pagina: this.qtd_por_pagina,
          },
        });
      },
      mudouQtdPagina: function (event) {
        const novaQtdPagina = parseInt(event.target.value);
        if (novaQtdPagina < this.qtd_por_pagina) {
          this.qtd_por_pagina = novaQtdPagina;
          this.mudouPagina(this.pagina);
        } else {
          let novaPagina = Math.ceil(
            (this.qtd_por_pagina * this.pagina) / novaQtdPagina
          );

          this.qtd_por_pagina = novaQtdPagina;
          this.mudouPagina(novaPagina);
        }
      },
      getParam: function (name) {
        if (this.$route && this.$route.query) {
          return this.$route.query[name];
        }
        return null;
      },
      mudouPagina: function (page) {
        this.pagina = page;

        const filtro = {
          cpf: this.getParam("cpf"),
          nome: this.getParam("nome"),
          cargo: this.getParam("cargo"),
        };

        this.$router.push({
          name: "Servidor",
          query: {
            ...filtro,
            pagina: this.pagina,
            qtd_por_pagina: this.qtd_por_pagina,
          },
        });
      },
      async carregarCargos() {
        try {
          if (this.carregandoFiltro && !this.erroFiltro) return;

          this.erroFiltro = false

          const dadosCargos = await this.servidorApi.getCargos();
          this.cargos = dadosCargos
        } catch (err) {
          console.log("carregarCargos", err);
          this.carregandoFiltro = false;
          this.erroFiltro = true;
          this.cargos = [];
        }
      },
      carregarValoresFiltro: async function () {
        try {
          if (this.carregandoFiltro && !this.erroFiltro) return;

          this.erroFiltro = false;
          /* this.carregandoFiltro = false; */

        } catch (err) {
          console.log("carregarValoresFiltro", err);
          this.carregandoFiltro = false;
          this.erroFiltro = true;
        }
      },
      carregarServidor: async function () {
        try {
          this.carregando = true;
          this.erro = false;

          this.qtd_por_pagina =
            this.getParam("qtd_por_pagina") || this.qtd_por_pagina;

          this.armazenarQtdPorPagina();

          const pagina = this.getParam("pagina") || 1;
          this.pagina = parseInt(pagina);

          this.filtro = {
            cpf: this.getParam("cpf"),
            nome: this.getParam("nome"),
            cargo: this.getParam("cargo"),
          };

          if (this.servidorApi.cancelTokens.getServidores) {
            this.servidorApi.cancelTokens.getServidores.cancel();
          }

          let data = await this.servidorApi.getServidores({
            ...this.filtro,
            qtd_por_pagina: this.qtd_por_pagina,
            page: this.pagina,
          });

          this.servidores = data.resultados;
          this.totalResultados = data.total_resultados;
          if (data.total_resultados >= 1000) {
            this.totalResultadosTexto = (data.total_resultados / 1000).toFixed(3).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          } else {
            this.totalResultadosTexto = data.total_resultados;
          }
          this.carregando = false;
        } catch (err) {
          if (this.servidorApi.isCancel(err)) {
            return;
          }
          console.log("carregarServidor", err);
          this.carregando = false;
          this.erro = true;
        }
      },
      limparFiltro: function () {
        this.tooglePesquisa();
        this.filtro = {
          cpf: undefined,
          nome: undefined,
          cargo: undefined,
        };
      },
      armazenarQtdPorPagina() {
        localStorage.setItem(
          "qtd_por_pagina_servidor",
          this.qtd_por_pagina
        );
      },
      carregarQtdPorPagina() {
        const qtd = localStorage.getItem("qtd_por_pagina_servidor");
        if (qtd) {
          this.qtd_por_pagina = tryParseInt(qtd);
        }
      },
    },
    computed: {
      pageCount: function () {
        if (
          this.totalResultados != undefined &&
          this.totalResultados != null &&
          this.qtd_por_pagina != null &&
          this.qtd_por_pagina != undefined &&
          this.totalResultados > 0 &&
          this.qtd_por_pagina > 0
        ) {
          return Math.ceil(this.totalResultados / this.qtd_por_pagina);
        }
        return 0;
      },
      filtered() {
        return this.cargos.filter((cargo) =>
          cargo.nome.toLowerCase().includes(this.search.toLowerCase())
        )
      },
      paginated() {
        return this.filtered.slice(this.offset, this.limit + this.offset)
      },
      hasNextPage() {
        const nextOffset = this.offset + this.limit
        return Boolean(
          this.filtered.slice(nextOffset, this.limit + nextOffset).length
        )
      },
      hasPrevPage() {
        const prevOffset = this.offset - this.limit
        return Boolean(
          this.filtered.slice(prevOffset, this.limit + prevOffset).length
        )
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>